/** @format */

import React from 'react';
import { SimpleSelect, SimpleSelectElements } from '../../../components/Adescom/SimpleSelect';
import PlatformResellerInterface from '../../../interfaces/platform/PlatformResellerInterface';
import { PlatformResellerSendType } from '../PlatformResellerModify';
import { useDispatch } from 'react-redux';
import Loader from '../../../components/Loaders/Loader';
import { useVats } from '../../../modules/document/useVats';
import CircularProgress from '@material-ui/core/CircularProgress';

interface PlatformResellerVatPropsInterface {
    platformResellerId: string | null | undefined;
    platformReseller: PlatformResellerInterface | PlatformResellerSendType;
    changeVatCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PlatformResellerVat: React.FC<PlatformResellerVatPropsInterface> = (props) => {
    const { platformReseller, platformResellerId } = props;
    const dispatch = useDispatch();
    const { vats, vatsSelect, triedLoading } = useVats();

    const saveCallback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        props.changeVatCallback(event);
    };

    const preprocessUri = (uri: string): string => {
        return '/api/' + uri.split('/api/')[1];
    };

    return (
        <>
            {vats && vats['hydra:member'] && (
                <SimpleSelect
                    label={'platform_reseller:pr.reseller_vat'}
                    required={true}
                    elements={vats['hydra:member'].map((el) => {
                        return {
                            name: `${el.description}`,
                            value: '/api/' + el['@id'].split('/api/')[1],
                        } as SimpleSelectElements;
                    })}
                    dispatchName={'vat'}
                    fieldName={'vat'}
                    selectedValue={preprocessUri(platformReseller.vat)}
                    callback={saveCallback}
                />
            )}
            {!vats && <CircularProgress />}
        </>
    );
};

export default PlatformResellerVat;
